/**
 * Component filter sticky 
 * 
 * @module filter-sticky
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'filter-sticky';

if (!customElements.get(customElements.component)) {

   class filterSticky extends HTMLElement {

   /**
    * Product filter sticky web component.
    * 
    * @constructor
    */
   constructor() {

   super();
   
   this.initEvents();
   }

   /**
    * Init module
    */
    initEvents()  {

        let filterBtn = document.querySelector('[data-button-fixed-desktop]');

        if(window.screenMode == 'mobile'  ) {
            filterBtn = document.querySelector('[data-button-fixed-mobile]');
        }

        this.onScroll(filterBtn); 
   }

    /**
    * Togle filter sticky on scroll
    */
    onScroll(filterBtn) {

        document.addEventListener('scroll', () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const objectOffsetTop = filterBtn.offsetTop;
          
            if (scrollTop >= objectOffsetTop) {
                this.classList.add("sticky");
            } else {
               this.classList.remove("sticky");
            }
        });
    }


   }

   customElements.define(customElements.component, filterSticky);
}
